import "./RefundReturnPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Refund from "./sections/Refund";
import Footer from "@/reusable_sections/Footer";
export default function RefundReturnPolicyPage() {
  return <div>
      <Header />
      <Refund />
      <Footer />
    </div>;
}